export enum AssetType {
    Well = 'Well',
    Facility = 'Facility',
    Pipeline = 'Pipeline',
    SRIRM = 'SRIRM',
}
